import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SERVIZI, MEDIA } from "@/data/content";
import { Check } from "lucide-react";

export default function Servizi() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }
  }, [hash]);

  return (
    <div data-testid="page-servizi" className="pt-28">
      <section className="container-x py-16 sm:py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="overline">Servizi</span>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight">
            Quattro pilastri.<br />Un unico <span className="italic text-primary">programma</span>.
          </h1>
          <p className="mt-8 lead max-w-2xl">
            Mettiamo a disposizione del cliente quattro aree di servizio integrate — dall'analisi del rischio alla negoziazione con il mercato — combinate in un programma assicurativo coerente.
          </p>
        </div>
      </section>

      <div className="container-x">
        <img src={MEDIA.services} alt="Texture astratta" className="w-full h-64 sm:h-96 object-cover" />
      </div>

      <section className="container-x section-y space-y-32">
        {SERVIZI.map((s, i) => (
          <article id={s.slug} key={s.slug} data-testid={`servizio-section-${s.slug}`} className="grid md:grid-cols-12 gap-10 scroll-mt-32">
            <div className="md:col-span-4">
              <p className="font-display text-7xl text-primary/20 leading-none">0{i + 1}</p>
              <h2 className="mt-6 font-display text-4xl sm:text-5xl leading-tight">{s.title}</h2>
              <p className="mt-4 text-primary font-medium">{s.short}</p>
            </div>
            <div className="md:col-span-7 md:col-start-6 space-y-8">
              <p className="text-lg text-muted-foreground leading-relaxed">{s.body}</p>
              <ul className="space-y-4 border-t border-foreground/10 pt-8">
                {s.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-4">
                    <Check className="h-5 w-5 mt-1 text-primary shrink-0" />
                    <span className="text-foreground">{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
